import { render, staticRenderFns } from "./BankingInformation.vue?vue&type=template&id=0d26c936"
import script from "./BankingInformation.vue?vue&type=script&lang=js"
export * from "./BankingInformation.vue?vue&type=script&lang=js"
import style0 from "./BankingInformation.vue?vue&type=style&index=0&id=0d26c936&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d26c936')) {
      api.createRecord('0d26c936', component.options)
    } else {
      api.reload('0d26c936', component.options)
    }
    module.hot.accept("./BankingInformation.vue?vue&type=template&id=0d26c936", function () {
      api.rerender('0d26c936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/BankingInformation/BankingInformation.vue"
export default component.exports